import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { User } from "@version2/domain-package";

interface UserState {
  userDoc: User | null;
  userId: string | null;
}

const initialState: UserState = {
  userDoc: null,
  userId: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDoc: (state, action: PayloadAction<any>) => {
      state.userDoc = action.payload;
    },
    setUserId: (state, action: PayloadAction<string | null>) => {
      state.userId = action.payload;
    }
  },
});

export const { setUserDoc, setUserId } = userSlice.actions;

export const selectUserDoc = (state: RootState) => state.user.userDoc;
export const selectUserId = (state: RootState) => state.user.userId;

export default userSlice.reducer;
